"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const ItemCard_1 = __importDefault(require("../ItemCard"));
const MotionDetail_1 = require("../../molecules/MotionDetail");
const bridge_1 = require("@completeanatomy/bridge");
const ui_1 = require("@completeanatomy/ui");
const react_router_dom_1 = require("react-router-dom");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const ui_2 = require("@completeanatomy/ui");
const device_1 = require("@completeanatomy/device");
const constants_1 = require("../../constants");
const analytics_1 = require("@completeanatomy/analytics");
const hooks_1 = require("../../hooks");
const noop_1 = __importDefault(require("lodash/noop"));
const OFFLINE_SNACKBAR = 'OfflineSnackbar';
function MotionsTab({ onResize = noop_1.default, isFull = false }) {
    const location = (0, react_router_dom_1.useLocation)();
    const { items = [] } = (0, hooks_1.useTabContent)(bridge_schema_1.InfoBoxTabType.Motion);
    const selectedItem = items === null || items === void 0 ? void 0 : items.find(item => item.isSelected);
    const bridge = (0, bridge_1.useBridge)();
    const isOffline = (0, device_1.useIsDeviceOffline)();
    const { show, register, unregister } = (0, ui_1.useSnackbar)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const analytics = (0, analytics_1.useAnalytics)();
    const sendAnalyticsEvent = (title) => {
        const segmentation = {
            name: title,
            toolType: bridge_schema_1.InfoBoxTabType.Motion,
            accessLocation: analytics_1.AnalyticsAccessLocation.Infobox,
        };
        analytics.log('InfoboxItemSelected', segmentation);
    };
    (0, react_1.useEffect)(() => {
        register(OFFLINE_SNACKBAR, ui_1.OfflineSnackbar);
        return () => unregister(OFFLINE_SNACKBAR);
    }, [register, unregister]);
    const getSize = (ref) => {
        if (!ref) {
            return;
        }
        const { width, height } = ref.getBoundingClientRect();
        onResize({ width, height });
    };
    const onClick = ({ identifier, title }, index) => () => {
        if (identifier === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.identifier)) {
            return;
        }
        if (isOffline && !items[index].isAvailable) {
            show(OFFLINE_SNACKBAR);
            return;
        }
        const replace = location.pathname.includes('motion');
        navigate(`/mode/${(0, constants_1.getTabKeyByType)(bridge_schema_1.InfoBoxTabType.Motion)}`, { replace });
        sendAnalyticsEvent(title);
        /**
         * For some reason calling bridge in the main process cause a lag for loading UI
         */
        setTimeout(() => {
            bridge === null || bridge === void 0 ? void 0 : bridge.selectInfoBoxListItem({
                type: bridge_schema_1.InfoBoxTabType.Motion,
                identifier,
                index,
            });
        }, 0);
    };
    const handleFade = (identifier, index) => () => {
        handleDetailPartClick(identifier, index);
        bridge === null || bridge === void 0 ? void 0 : bridge.toggleFadeMotionAction({ type: bridge_schema_1.InfoBoxTabType.Motion, identifier });
    };
    const handleFadeAll = () => bridge === null || bridge === void 0 ? void 0 : bridge.toggleFadeAllMotionActions({ type: bridge_schema_1.InfoBoxTabType.Motion });
    const handleDetailPartClick = (identifier, index) => {
        bridge === null || bridge === void 0 ? void 0 : bridge.selectInfoBoxListItem({
            type: bridge_schema_1.InfoBoxTabType.Motion,
            identifier,
            index,
        });
    };
    return ((0, jsx_runtime_1.jsx)(ui_2.SimpleScrollView, { "$vertical": true, ref: getSize, "data-e2e": 'MotionsTab_SimpleScrollView', children: (items || []).map((item, i) => {
            return ((0, jsx_runtime_1.jsx)(ItemCard_1.default, Object.assign({}, item, { img: item.img, onClick: onClick(item, i), disabled: isOffline && !item.isAvailable, "data-e2e": 'MotionsTab_ItemCard', children: isFull && item.detail && ((0, jsx_runtime_1.jsx)(MotionDetail_1.MotionDetail, { detail: item.detail, onClick: handleDetailPartClick, onFade: handleFade, onFadeAll: handleFadeAll, "data-e2e": 'MotionsTab_MotionDetail' })) }), i));
        }) }));
}
exports.default = react_1.default.memo(MotionsTab, () => true);
